// The two fixed orders of the round kinds (R2017, R2783). A leaf module:
// `state.ts` reads the hold order, and `ui/rounds.ts` re-exports both, so
// neither needs the other's imports.

import { TorpedoKind } from '../gen/proto/aquaphobia';

/** What the round modules read of one round spec of the hello catalog. */
export interface RoundSpec {
  id: number;
  name: string;
  cargo: number;
  fromBase: boolean;
}

/**
 * The fixed order of the ship rounds (R2017): every kind of the catalog
 * that no base fires, in enum order. The server builds the same list from
 * the same pack.
 */
export function roundOrder(torpedoes: readonly RoundSpec[]): number[] {
  return torpedoes.filter((t) => !t.fromBase && t.id > 0).map((t) => t.id).sort((a, b) => a - b);
}

/**
 * The kinds a hold fires (R2779 rule 10, R2783): the base kinds in catalog
 * order, then the ship kinds in the fixed order. The quill pod is a round
 * of the NPC side, and the server refuses it from a hold, so it never
 * stands in the list.
 */
export function holdRoundOrder(torpedoes: readonly RoundSpec[]): number[] {
  const base = torpedoes.filter((t) => t.fromBase && t.id > 0).map((t) => t.id);
  return [...base, ...roundOrder(torpedoes).filter((k) => k !== TorpedoKind.TORPEDO_KIND_POD)];
}
